import React from 'react';
const BUTTERFLY_URL = 'https://cdn.magicpatterns.com/uploads/qKFpaFgVdjF6b66gh5Dqtu/butterfly_logo_hd.png';
/**
 * Decorative butterfly using the actual EnMedical Systems butterfly logo.
 * Used as subtle background branding across sections.
 */
export function ButterflyDecor({
  className = ''
}: {
  className?: string;
  color1?: string;
  color2?: string;
}) {
  return <img src={BUTTERFLY_URL} alt="" aria-hidden="true" draggable={false} className={className} data-id="element-440" />;
}